module.exports = __webpack_public_path__ + "static/img/11.ec340a4f.png";